import React from "react";
import "./CareersSection.css";
import careerImage from "../../assets/Careers-graphics.png";
import { motion as MotionDiv } from "framer-motion";
import FloatingDots from "../FloatingDots"; 

export default function CareersTwoColumn() {
  const mailTo = (position = "") => {
    const subject = encodeURIComponent(
      `Application - ${position || "Interested Position"}`
    );
    return `mailto:info@newzealacademy.com?subject=${subject}`;
  };

  return (
    <section className="careers-container">
      <div className="careers-grid">
        {/* Left Section */}
        <aside className="careers-left">
  <h2>Join <span className="highlight">Sreenathji Enterprises</span></h2>

  <p>
    Our growth has always been powered by people. At{" "}
    <strong>Sreenathji Enterprises</strong>, we believe in nurturing talent,
    encouraging innovation, and providing a platform for professionals to grow.
  </p>

  <ul style={{ color: "#555" }}>
    <li>Administration</li>
    <li>Accounts</li>
    <li>Sales </li>
    <li>Logistics</li>
    <li>HR</li>
  </ul>

  <p>
    If you are passionate Plating and Specialty Chemicals, Basic and Lab Chemicals, Metals, Abrasives, Cutting Tools, Wood & Glass Coatings, Metal Coatings, <strong>SE</strong> is the right place
    to build your career.
  </p>
</aside>


        {/* Right Section (Image) */}
        <div className="careers-right">
           <FloatingDots />
          <img
            src={careerImage}
            alt="Careers at NewZeal Academy"
            className="career-image"
          />
        </div>
      </div>
    </section>
  );
}
